var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCrossBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4045_854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 10.586L16.2432 6.34299C16.6337 5.95252 17.2668 5.95252 17.6572 6.34299C18.0477 6.73345 18.0477 7.36652 17.6572 7.75699L13.4142 12L17.6572 16.243C18.0477 16.6335 18.0477 17.2665 17.6572 17.657C17.2668 18.0475 16.6337 18.0475 16.2432 17.657L12.0002 13.414L7.75723 17.657C7.36677 18.0475 6.7337 18.0475 6.34323 17.657C5.95277 17.2665 5.95277 16.6335 6.34323 16.243L10.5862 12L6.34323 7.75699C5.95277 7.36652 5.95277 6.73345 6.34323 6.34299C6.7337 5.95252 7.36677 5.95252 7.75723 6.34299L12.0002 10.586Z",
    fill: "#2B2C82"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4045_854"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCrossBlue);
export default __webpack_public_path__ + "static/media/icon-cross-blue.f6dbe11e41b2a756bcf3dc6322fab61b.svg";
export { ForwardRef as ReactComponent };